(() => {
  const button = document.querySelector('.wearshopx-menu-toggle');
  const menu = document.querySelector('#wearshopx-menu');
  if (!button || !menu) return;
  button.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!open));
    button.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
    menu.hidden = open;
  });
  menu.addEventListener('click', (event) => {
    if (event.target.closest('a')) {
      button.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    }
  });
})();

(() => {
  document.querySelectorAll('[data-wx-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('.wearshopx-campaign-slide'));
    const dots = Array.from(carousel.querySelectorAll('[data-wx-slide]'));
    const previous = carousel.querySelector('[data-wx-previous]');
    const next = carousel.querySelector('[data-wx-next]');
    if (slides.length < 2 || !previous || !next || dots.length !== slides.length) return;

    let active = 0;
    let timer = null;
    let paused = false;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const current = i === active;
        slide.classList.toggle('is-active', current);
        slide.setAttribute('aria-hidden', String(!current));
        if (current) slide.removeAttribute('tabindex');
        else slide.setAttribute('tabindex', '-1');
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === active)));
    };
    const stop = () => { window.clearInterval(timer); timer = null; };
    const start = () => {
      stop();
      if (!paused && !document.hidden && !reducedMotion.matches) {
        timer = window.setInterval(() => show(active + 1), 5500);
      }
    };

    previous.addEventListener('click', () => { show(active - 1); paused = false; start(); });
    next.addEventListener('click', () => { show(active + 1); paused = false; start(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); paused = false; start(); }));
    carousel.addEventListener('mouseenter', () => { paused = true; stop(); });
    carousel.addEventListener('mouseleave', () => { paused = false; start(); });
    carousel.addEventListener('focusin', () => { paused = true; stop(); });
    carousel.addEventListener('focusout', (event) => {
      if (!carousel.contains(event.relatedTarget)) { paused = false; start(); }
    });
    document.addEventListener('visibilitychange', start);
    reducedMotion.addEventListener?.('change', start);
    show(0);
    start();
  });
})();

